<script>
import { Scatter } from 'vue-chartjs'
import axios from "axios";

export default {
  extends: Scatter,
  mounted () {
    let green = '#337979'
    let red = '#cc3333'
    let blue = '#3333cc'
    let url = "https://roxy.lab.ovaielo.se/api/v1/metrics?samples=168"
    //let url = "http://localhost:8080/api/v1/metrics?samples=168"

    axios.get(url).then(
      response => {
      let convert_to_ms = function(v) {
        return {x: v.x*1000, y: v.y}
      }
      this.renderChart({
      datasets: [
        {
          yAxisID: 'hundred',
          fill: false,
          label: 'luftfuktighet [%]',
          showLine: true,
          lineTension: 0,
          borderColor: green,
          data: response.data.humidity.map(convert_to_ms)
        },
        {
          yAxisID: 'gram_per_m3',
          fill: false,
          label: 'Absolut luftfuktighet [g/m3]',
          showLine: true,
          lineTension: 0,
          borderColor: blue,
          data: response.data.abs_humidity.map(convert_to_ms)
        },
        {
          yAxisID: 'temp',
          fill: false,
          label: 'temperatur [°C]',
          showLine: true,
          lineTension: 0,
          borderColor: red,
          data: response.data.temp.map(convert_to_ms)
        },

      ]
    }, {
      responsive: true,
      maintainAspectRatio: false,
      animation: {
        duration: 0
      },
      title: {
        text: "Roxy Monitoring",
        display: false
      },
      scales: {
        yAxes: [{
          id: 'hundred',
          position: 'left',
            scaleLabel: {
              labelString: "%",
              display: true,
              fontColor: green
            },
            ticks: {
              fontColor: green
            }
        },
        {
          id: 'gram_per_m3',
          position: 'left',
            scaleLabel: {
              labelString: "g/m3",
              display: true,
              fontColor: blue
            },
            ticks: {
              fontColor: blue
            }
        },
        {
          id: 'temp',
          position: 'right',
            scaleLabel: {
              labelString: "°C",
              display: true,
              fontColor: red
            },
            ticks: {
                fontColor: red
            }
        }],
        xAxes: [{
          type: "time",
          time: {
            unit: 'hour',
            displayFormats: {
              hour: 'MMM D, HH'
            }
          },
          distribution: 'series',
          ticks: {
             autoSkip: true,
             maxTicksLimit: 10
          }
        }]
      }
    })
  })
}}
</script>
